import React, { useState, useRef, useEffect } from "react";
import Header from "parts/Header";
import { Fade } from "react-awesome-reveal";
import ImageOne from "../assets/images/AwardsImages_MAM/HR.jpg";
import ImageTwo from "../assets/images/AwardsImages_MAM/imagetwo.jpeg";
import ImageThree from "../assets/images/AwardsImages_MAM/image6.jpeg";
import ImageFour from "../assets/images/AwardsImages_MAM/carousel_1.jpeg";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from "parts/Footer";

const FounderPersonTwo = () => {
  const images = [ImageTwo, ImageThree, ImageFour];
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
  };

  const stopAutoSlide = () => clearInterval(intervalRef.current);

  const prevSlide = () => {
    stopAutoSlide();
    setIndex((prev) => (prev - 1 + images.length) % images.length);
    startAutoSlide();
  };

  const nextSlide = () => {
    stopAutoSlide();
    setIndex((prev) => (prev + 1) % images.length);
    startAutoSlide();
  };

  useEffect(() => {
    startAutoSlide();
    return stopAutoSlide;
  }, []);

  return (
    <>
      <Header />
      {/* Content  */}
      <section className="flex flex-col lg:flex-row w-11/12 lg:w-11/12 pt-5 lg:pt-12 lg:mx-auto lg:items-start sm:items-center mx-auto">
        <div className="w-full sm:w-1/2 sm:pr-12">
          <Fade direction="up" triggerOnce>
            <img
              src={ImageOne}
              alt="Hero"
              className="w-full h-[400px] object-contain rounded-2xl"
            />
          </Fade>
        </div>

        <div className="w-full sm:w-1/2 flex flex-col  px-5 sm:mb-0 lg:mt-0">
          <Fade direction="up" triggerOnce>
            <h1 className="text-[34px] text-theme-blue font-bold leading-tight mb-5">
              Co-Founder & HR's Message
            </h1>
          </Fade>
          <Fade direction="up" triggerOnce delay={400}>
            <p className="font-light text-xl text-gray-400 text-justify leading-relaxed">
              As a mathematician with a passion for people, I merged logic with
              empathy to shape SCODE’s soul — its people and culture. At SCODE,
              we don’t just build apps; we build lives, with policies rooted in
              trust, empathy, and absolute support. My role as a Co-founder & HR
              leader is to ensure every team member feels seen, valued, and
              empowered to rise. In a world obsessed with hustle, we choose
              balance — where mental wellness, family time, and growth coexist.
              SCODE is not just a workplace; it’s a vibrant ecosystem where
              innovation breathes and every individual thrives.Our Motto is
              "Empowering the young minds".
            </p>
          </Fade>
        </div>
      </section>

      {/* Achievements */}

      <section className="flex flex-col lg:flex-row w-11/12 lg:w-11/12  lg:pt-1 lg:mx-auto lg:items-start sm:items-center mx-auto">
        <div className="w-full sm:w-1/2 flex flex-col pt-12 px-5 sm:mb-0 lg:mt-0">
          <Fade direction="up" triggerOnce>
            <h1 className="text-[34px] text-theme-blue font-bold text-center leading-tight mb-5">
              Awards & Achievements
            </h1>
          </Fade>
          <Fade direction="up" triggerOnce delay={400}>
            <p className="font-light text-xl text-gray-400 leading-relaxed">
              Throughout my professional journey, I have consistently
              demonstrated dedication and excellence, earning several accolades.
            </p>
          </Fade>
        </div>

        <div className="w-full sm:w-1/2 flex flex-col px-5 sm:mb-0 lg:mt-0">
          <div className="max-w-3xl mx-auto mt-10 relative overflow-hidden">
            {/* Slide Container */}
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{
                transform: `translateX(-${index * 100}%)`,
                width: `${images.length * 37}%`,
              }}
            >
              {images.map((src, i) => (
                <div
                  key={i}
                  className="min-w-full h-[300px] flex items-center  justify-center"
                  // Each slide takes 100% width
                >
                  <img
                    src={src}
                    alt={`Slide ${i + 1}`}
                    className="h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Controls */}
            <button
              onClick={prevSlide}
              disabled={index === 0}
              className={`absolute top-1/2 left-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-200 transition-opacity duration-300 ${
                index === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <FaArrowLeft />
            </button>
            {/* Next Button */}
            <button
              onClick={nextSlide}
              disabled={index === images.length - 1}
              className={`absolute top-1/2 right-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-200 transition-opacity duration-300 ${
                index === images.length - 1
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <FaArrowRight />
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FounderPersonTwo;
